import { Link } from "gatsby";
import { ABOUT_URL } from "../../../../src/constants/pageUrls";
import * as React from 'react';
export default {
  Link,
  ABOUT_URL,
  React
};